import { useEffect } from "react";

import { usePathname } from "next/navigation";
import { pageview } from "../functions/gtm";
import useIsClient from "@/hooks/useIsClient";
import useShouldFire from "./useShouldFire";

const useGoogleAnalytics = (id: string | number, refresh?: boolean) => {
  const pathname = usePathname();
  const client = useIsClient();
  const shouldFire = useShouldFire();
  useEffect(() => {
    if (!id || !client || !shouldFire) return;
    pageview(pathname);
  }, [pathname, client, id, refresh]);
};
export default useGoogleAnalytics;
